import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: 'white',
    boxShadow: 24,
    p: 4,
    borderRadius: '5px',
    width: '600px',
};

export const ConfirmationModal = ( {header, description, isOpen, setIsOpen, onConfirm} ) => {
    return (
        <Modal
            open={isOpen}
            onClose={() => setIsOpen(null)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className={'BaseModal'}
        >
            <Box
                style={{
                    ...style,
                    // maxWidth: '515px',
                    padding: '31px 57px 60px 56px'
                }}
            >
                <Stack
                    direction="column"
                    justifyContent="space-between"
                    alignItems="left"
                    className={''}
                >
                    <Typography
                        gutterBottom
                        variant="h5"
                        component="div"
                        className={'DealRebateModal-name'}
                    >
                        {header}
                    </Typography>
                    <Divider className={'divider'} sx={{ marginBottom: '10px'}}/>
                    <Typography
                        gutterBottom
                        variant="subtitle1"
                        component="div"
                        className={'DealRebateModal-description'}
                    >
                        {description}
                    </Typography>

                    <Divider className={'divider'} sx={{ marginBottom: '10px'}}/>

                    <Button
                        style={{
                            alignSelf: 'end'
                        }}
                        color="error"
                        onClick={() => {
                            onConfirm()
                            setIsOpen(false)
                        }}
                    >
                        Confirm
                    </Button>

                </Stack>
            </Box>
        </Modal>
    )
}